/**
 * Shared query config for the home page hooks.
 *
 * Exists so `useHomePageData` and `useHomeOnboardingStatus` can agree on the
 * cache key prefix without importing each other. That coupling is what the
 * split was for: `HomeRouter` only needs the onboarding hook, and pulling it
 * from `useHomePageData` dragged that module's member-only API imports
 * (observability audit, incident knowledge, contributions) into the eager
 * chunk for the whole route.
 *
 * Keeping the key in one place matters more than the few lines saved. Two
 * copies of `HOME_QUERY_KEY` drift the moment one is edited, and a drifted
 * prefix means invalidation silently stops matching the entries it should
 * clear. This file imports nothing, so both hooks can depend on it freely.
 */
export const HOME_QUERY_KEY = 'home';

export const retryFn = (failureCount: number, error: unknown) => {
  const msg = error instanceof Error ? error.message : '';
  if (msg.includes('timeout') || msg.includes('broken pipe')) {
    return false;
  }
  return failureCount < 2;
};

export const retryDelay = (attemptIndex: number) =>
  Math.min(1000 * 2 ** attemptIndex, 30000);
